import React, { PropTypes } from 'react'
import { Link } from 'react-router';

const EmptyDraft = () => (
  <div>
    <h3>You don&apos;t have any drafts right now.</h3>
    <div className="empty-state-cta">
      <Link className="btn btn-primary" to="/start-a-project/">Start a new project</Link>
    </div>
  </div>
);

const EmptyActive = () => (
  <div>
    <h3>You don&apos;t have any active projects right now.</h3>
    <div className="empty-state-cta">
      <Link className="btn btn-primary" to="/start-a-project/">Start a new project</Link>
    </div>
  </div>
);

const EmptyWrapup = ({ userType }) => (
  <div>
    <h3>You don&apos;t have any projects in wrap-up right now.</h3>
    <p>
      { userType === 'client'? 'When you award a project, it will appear here.' :
      'When you receive an award in a project, the project will appear here.' } <br/>
      To understand how wrap-ups work, check out our Illustrated Guides
      to <Link to="/help/guides/design-projects-wrapup/">Design</Link> and
      <Link to="/help/guides/naming-projects-wrapup/"> Naming</Link> Wrap-ups.
    </p>
  </div>
);

const EmptyCompleted = () => (
  <div>
    <h3>You haven&apos;t completed any projects yet.</h3>
    <div className="empty-state-cta">
      <Link className="btn btn-primary" to="/start-a-project/">Start a new project</Link>
    </div>
  </div>
);

const EmptyWatchlist = () => (
  <div>
    <h3>You aren&apos;t watching any projects.</h3>
    <div className="empty-state-cta">
      <Link className="btn btn-primary"
          to="/explore/?explore_projects_filter_checkboxes_status=open">
        Find something to work on
      </Link>
    </div>
  </div>
);

const EmptyParticipating = () => (
  <div>
    <h3>You aren&apos;t participating in any projects right now.</h3>
    <div className="empty-state-cta">
      <Link className="btn btn-primary"
          to="/explore/?explore_projects_filter_checkboxes_status=open">
        Find projects
      </Link>
    </div>
  </div>
);

const EmptyWon = () => (
  <div>
    <h3>You haven&apos;t won any projects yet.</h3>
    <div className="empty-state-cta">
      <Link className="btn btn-primary"
          to="/explore/?explore_projects_filter_checkboxes_status=open">
        Find projects
      </Link>
    </div>
  </div>
);

const EmptyHistory = () => (
  <div>
    <h3>You don&apos;t have any projects in history yet.</h3>
    <div className="empty-state-cta">
      <Link className="btn btn-primary"
          to="/explore/?explore_projects_filter_checkboxes_status=open">
        Find projects
      </Link>
    </div>
  </div>
);

const CONTENT_MAP = {
  client: {
    drafts: EmptyDraft,
    active: EmptyActive,
    wrapup: EmptyWrapup,
    complete: EmptyCompleted
  },
  creative: {
    watchlist: EmptyWatchlist,
    participating: EmptyParticipating,
    wrapup: EmptyWrapup,
    awarded: EmptyWon,
    history: EmptyHistory
  }
}

const EmptyGallery = ({ userType, projectType }) => {
  const Content = CONTENT_MAP[userType][projectType];

  return (
    <div className="empty-state no-results">
      <div className="empty-state-content">
        <Content userType={userType} />
      </div>
    </div>
  );
}

EmptyGallery.propTypes = {
  userType: PropTypes.string.isRequired,
  projectType: PropTypes.string.isRequired,
};

export default EmptyGallery;



// WEBPACK FOOTER //
// ./your_projects/components/empty_gallery.jsx